import { makeStyles } from "@material-ui/core"

const ideaEditStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    border: "1px solid #E7EAED",
    borderRadius: "8px",
    width: "100%",
    padding: "1.5rem !important",
    margin: 0,
  },
  sticky: {
    position: "sticky",
    top: "100px",
  },
  title: {
    fontSize: 14,
    color: '#343A40',
    marginRight: '0.5rem',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: 14,
  }, 
  status: {
    padding: '0.5rem',
    color: '#fff',
    textTransform: 'uppercase',
    borderRadius: '0.5rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  iconHeader: {
    background: '#E5CCE7',
    width: 40,
    height: 40,
    borderRadius: '50%',
    marginRight: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleCard: {
    fontSize: 20,
    fontWeight: 600
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12.5,
    textTransform: 'lowercase',
    paddingTop: theme.spacing(5),
    color: "#999",
  },
  actionButton: {
    width: '100%',
  },
  linkTitle: {
    fontSize: 14,
    color: '#434343',
    fontWeight: 600,
    paddingRight: 8,
    minWidth: 'fit-content'
  },
}))

export { ideaEditStyles }